import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useGetVehicleManufacturers } from "../../../queries/useGetVehicleManufacturers";
import { useSearchForm } from "../../../stores/hooks/useSearchForm";
import { ComboBox } from "../../../ui/ComboBox/ComboBox";
import { Input } from "../../../ui/Input/Input";
import { Spinner } from "../../../ui/Spinner";
import { ChevronRightIcon } from "../../../ui/icons/ChevronRightIcon";
import { SlidersIcon } from "../../../ui/icons/SlidersIcon";
import { usePlacement } from "./usePlacement";

type Props = {
  forcePrimaryManufacturers?: boolean;
};

export const MakeInput: FunctionComponent<Props> = ({
  forcePrimaryManufacturers,
}) => {
  const { t } = useTranslation();
  const { data, isLoading } = useGetVehicleManufacturers({
    forcePrimary: forcePrimaryManufacturers,
  });
  const [{ vehicleManufacturerName, vehicleYear }, { setMake }] =
    useSearchForm();

  const open = !vehicleManufacturerName && !!data;
  const readOnly = !data;

  return (
    <ComboBox
      onSelectOption={(option): void => {
        setMake(option?.label || null);
      }}
      defaultValue={vehicleManufacturerName ?? ""}
      id="make-combo"
      open={open}
      options={data || []}
      placement={usePlacement()}
    >
      <Input
        after={isLoading ? <Spinner /> : <ChevronRightIcon />}
        aria-label="vehicleManufacturerName"
        before={<SlidersIcon />}
        disabled={!vehicleYear}
        name="make"
        placeholder={t("searchForm.selectMake")}
        readOnly={!readOnly}
        ring={!vehicleManufacturerName && !readOnly}
        value={vehicleManufacturerName || ""}
      />
    </ComboBox>
  );
};

/**
 * @see docs/worklog/TW-914-standalone-accessories-site-changes/rfc.md
 * @see docs/worklog/TW-914-standalone-accessories-site-changes/tfc.md
 */
